import { IStaticAccordion } from "../../../../../Contracts/StaticDataAccordion";
import { LegislationSections } from "../../../../Model/Enum/BEE123Enums";

export const WspAtr_MerSETA_Templates : Array<IStaticAccordion> = [
    {
      title: "ALL SETA's",
      groups: [
        {
          items: [
            {
              title: "SDF Appointment template",
              link:
                "",
              section: LegislationSections.MerSETA_Templates
            },
            {
              title: "Training Committee appointment letter",
              link:
                "",
              section: LegislationSections.MerSETA_Templates
            },
            {
              title: "OFO Codes",
              link:
                "OFO-Codes_V2021.xls",
              section: LegislationSections.MerSETA_Templates
            },
          ],
        },
      ],
      
    },
    {
      title: "merSETA",
      groups: [
        {
          items: [
            {
              title: "WSP",
              link:
                "WSPCSVTemplate_2024.csv",
              section: LegislationSections.MerSETA_Templates
            },
            {
              title: "ATR",
              link:
                "ATRCSVTemplate_2023.csv",
              section: LegislationSections.MerSETA_Templates
            },
            {
              title: "Workforce profile",
              link:
                "Workforce Profile and Options.xlsx",
              section: LegislationSections.MerSETA_Templates
            },
            {
              title: "WSP/ATR Lookup Codes file",
              link:
                "ATRandWSPLookupCodes_2023-24.xlsx",
              section: LegislationSections.MerSETA_Templates
            },
          ],
        },
      ],
      
    }
  ];
  